<template>
  <v-container
    fluid
    grid-list-xl
  >
    <perfil :usuario="usuario" />
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import Perfil from '@/components/perfil/Perfil';

export default {
  name: 'MeuPerfil',

  components: { Perfil },

  computed: {
    ...mapState({
      usuario: (state) => state.auth.usuario,
    }),
  },
};
</script>
